"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.SAP_QUARTZ_THEMES_BRANDING_ID = exports.SAP_HORIZON_THEMES_BRANDING_ID = exports.PRESELECTED_DENSITY = exports.GATEWAY_HORIZON_THEMES_BRANDING_ID = exports.GATEWAY_BRANDING_ID = exports.ERROR_LEVELS = exports.ERROR_CATEGORY = exports.CONCUR_THEMES_BRANDING_ID = void 0;
var GATEWAY_BRANDING_ID = exports.GATEWAY_BRANDING_ID = 12;
var CONCUR_THEMES_BRANDING_ID = exports.CONCUR_THEMES_BRANDING_ID = 13;
var SAP_QUARTZ_THEMES_BRANDING_ID = exports.SAP_QUARTZ_THEMES_BRANDING_ID = 14;
var GATEWAY_HORIZON_THEMES_BRANDING_ID = exports.GATEWAY_HORIZON_THEMES_BRANDING_ID = 15;
var SAP_HORIZON_THEMES_BRANDING_ID = exports.SAP_HORIZON_THEMES_BRANDING_ID = 16;
var PRESELECTED_DENSITY = exports.PRESELECTED_DENSITY = 'cozy';
var ERROR_LEVELS = exports.ERROR_LEVELS = {
  ERROR: 'ERROR',
  INFO: 'INFO'
};
var ERROR_CATEGORY = exports.ERROR_CATEGORY = 'core-ui-shell';